(function (factory) {
    typeof define === 'function' && define.amd ? define(factory) :
    factory();
})((function () { 'use strict';

    /**
     * Conditional logic for showing / hiding fields in Contact Form 7.
     *
     * The parent select should have the class ".conditional-owner".
     *
     * For the hidden / shown elements, data-group is the parent select name, and
     * data-option is the parent select value that should display the element.
     *
     * Example usage:
     *
     * <p class="gf_left_half">
     * <label for="carbon_applications_interest">Application of Interest <span class="req">*</span></label>
     * [select* carbon_applications_interest class:applications-interest class:conditional-owner include_blank]
     * </p>
     *
     * <p class="gf_right_half" data-group="carbon_applications_interest" data-option="">
     * <label for="carbon_applications_automotive">Select an Application</label>
     * [select carbon_applications_placeholder "Please select an application of interest."]
     * </p>
     *
     * <p class="gf_right_half hidden-target" data-group="carbon_applications_interest" data-option="Automotive">
     * <label for="carbon_applications_automotive">Automotive Applications</label>
     * [select carbon_applications_automotive class:applications-auto include_blank]
     * </p>
     *
     * <p class="gf_right_half hidden-target" data-group="carbon_applications_interest" data-option="Military">
     * <label for="carbon_applications_military">Military Applications</label>
     * [select carbon_applications_military class:applications-military include_blank]
     * </p>
     */
    (() => {
        const conditionalSelects = document.querySelectorAll(
            '.wpcf7-form .conditional-owner'
        );
        if (!conditionalSelects.length) {
            return;
        }

        conditionalSelects.forEach((select) => {
            select.addEventListener('change', () => {
                const selectName = select.name;
                const selectedOption = select.value;

                const groupElements = document.querySelectorAll(
                    `[data-group="${selectName}"]`
                );

                groupElements.forEach((element) => {
                    if (element.getAttribute('data-option') === selectedOption) {
                        element.classList.remove('hidden-target');
                    } else {
                        element.classList.add('hidden-target');
                    }
                });
            });
        });
    })();

}));
